/**
 * Cache layer around the generated ResourceControllerService.getOvenCapacity client.
 * The endpoint itself (`GET /api/resources/ovenCapacity?materialId=...`) returns the
 * number of oven resources available for a material, plus the oven resource type —
 * used by `campaignSplittingService.ts` to decide whether and how to split a campaign.
 *
 * In-memory cache per materialId avoids repeat calls from the wizard. Scope is
 * module-level — cleared on page reload, which is fine for the wizard flow.
 */

import { ResourceControllerService } from '../api/services/ResourceControllerService';
import type { OvenCapacityDto } from '../api/models/OvenCapacityDto';

const cache = new Map<string, Promise<OvenCapacityDto>>();

export function getOvenCapacityCached(materialId: string): Promise<OvenCapacityDto> {
  if (!cache.has(materialId)) {
    cache.set(
      materialId,
      Promise.resolve(ResourceControllerService.getOvenCapacity(materialId)).catch(err => {
        cache.delete(materialId);
        throw err;
      })
    );
  }
  return cache.get(materialId)!;
}
